const NAMESPACE = "legacyESignatureCapsuleTable";

const KEYS = {
    dateHeader: "dateHeader",
    documentsHeader: "documentsHeader",
    signatoriesHeader: "signatoriesHeader",
    statusHeader: "statusHeader",
    emptyTabelText: "emptyTabelText"
};

const MESSAGES = {
    [KEYS.dateHeader]: {
        value: "Date",
        comment: "Header for the Date column"
    },
    [KEYS.documentsHeader]: {
        value: "Documents",
        comment: "Header for the Documents column"
    },
    [KEYS.signatoriesHeader]: {
        value: "Signatories",
        comment: "Header for the Signatories column"
    },
    [KEYS.statusHeader]: {
        value: "Status",
        comment: "Header for the Status column"
    },
    [KEYS.emptyTabelText]: {
        value: "There are no eSignatures for this project.",
        comment: "Text that displays when there is no eSignatures to display"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
